import React from "react";
import { Link } from "react-router-dom";
import Header from "../header";
import Navvbar from "../Navvbar";
import "./labSett.css";

const LabSetting = () => {
  const settingsList = [
    {
      title: "Lab Details",
      path: "/Tabs",
      description:
        "Manage your DDX lab details, including lab contact information, logo, and payment processing.",
    },
    {
      title: "Store",
      path: "/",
      description: "Manage your add-ons and settings.",
    },
    {
      title: "Users",
      path: "/users",
      description:
        "Manage DDX users for your lab, including adding new users and updating existing.",
    },
    {
      title: "Permission Groups",
      path: "/",
      description: "Manage permissions groups for your users.",
    },
    {
      title: "Accounts",
      path: "/accountTable",
      description: "View your existing DDX accounts.",
    },
    {
      title: "Finances",
      path: "/financeOwerview",
      description: "Manage your finance settings, such as taxes and invoicing.",
    },
    {
      title: "Case Settings",
      path: "/caseSetting",
      description:
        "Manage your case settings, such a available case procedures, materials, enclosures, and more.",
    },
  ];

  return (
    <div className="lab-setting-wrapper">
      <Header />
      <Navvbar />

      <div className="container-fluid lab-setting-container">
        <div className="lab-setting-row">
          {/* Left Sidebar */}
          <div className="sidebar-col">
            <div className="my-sidebar">
              <h2 className="my-sidebar-title">Settings</h2>
              <div className="my-sidebar-links">
                <Link to="/lab-details" className="my-sidebar-link">Lab Details</Link>
                <Link to="#" onClick={(e) => e.preventDefault()} className="my-sidebar-link my-sidebar-disabled">Store</Link>
                <Link to="/users" className="my-sidebar-link">Users</Link>
                <Link to="#" onClick={(e) => e.preventDefault()} className="my-sidebar-link my-sidebar-disabled">Permission Groups</Link>
                <Link to="/accountTable" className="my-sidebar-link">Accounts</Link>
                <Link to="/financeOwerview" className="my-sidebar-link">Finances</Link>
                <Link to="/owersetting" className="my-sidebar-link">Case Settings</Link>
              </div>
            </div>
          </div>

          {/* Right Main Content */}
          <div className="main-content-col">
            <h2 className="main-title">My Lab Settings</h2>

            <div className="settings-content-list">
              {settingsList.map((item, index) => (
                <div key={index} className="setting-item">
                  <Link to={item.path} className="setting-item-title">
                    {item.title}
                  </Link>
                  <p className="setting-item-desc">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LabSetting;